"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonType = void 0;
var ButtonType;
(function (ButtonType) {
    ButtonType[ButtonType["Destructive"] = 0] = "Destructive";
    /** @deprecated use `Destructive` */ ButtonType[ButtonType["Attention"] = 0] = "Attention";
    /** @deprecated use `Destructive` */ ButtonType[ButtonType["OutlineAttention"] = 6] = "OutlineAttention";
    ButtonType[ButtonType["Primary"] = 2] = "Primary";
    /** @deprecated use `Primary` */ ButtonType[ButtonType["Go"] = 2] = "Go";
    /** @deprecated use `Primary` */ ButtonType[ButtonType["OutlineGo"] = 5] = "OutlineGo";
    ButtonType[ButtonType["Outline"] = 3] = "Outline";
    /** @deprecated use `Outline` */ ButtonType[ButtonType["Grey"] = 1] = "Grey";
    ButtonType[ButtonType["OutlineDark"] = 4] = "OutlineDark";
    /** @deprecated use `OutlineDark` */ ButtonType[ButtonType["LightOutline"] = 4] = "LightOutline";
    ButtonType[ButtonType["LowEmphasis"] = 9] = "LowEmphasis";
    /** @deprecated use `LowEmphasis` */ ButtonType[ButtonType["Text"] = 7] = "Text";
    /** @deprecated use `LowEmphasis` */ ButtonType[ButtonType["DarkText"] = 8] = "DarkText";
    /** @deprecated use `LowEmphasis` */ ButtonType[ButtonType["DarkBoldText"] = 9] = "DarkBoldText";
    ButtonType[ButtonType["Icon"] = 10] = "Icon";
    ButtonType[ButtonType["IconOutline"] = 11] = "IconOutline";
})(ButtonType = exports.ButtonType || (exports.ButtonType = {}));
//# sourceMappingURL=ButtonWidget.js.map